import React from "react";
import './index.sass'
import Svg from '../Svg';

export default class Logo extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className='logo'>
                <Svg.logo />
            </div>
        )
    }
}